import { createHooksActions, createHooksSelectors } from 'src/helpers/redux'
import * as store from 'src/store/modules/assistant'

export { store }

export * from 'src/store/modules/assistant/state'

export const useAssistantSelect = createHooksSelectors<
  typeof store.selectors.selectors
>(store.selectors.selectors)

export const useAssistantAction = createHooksActions<typeof store.actions>(
  store.actions,
  store.selectors.communications
)
